export function freeTier(id: string) {
  return id === '';
}

export function proTier(id: string) {
  return /p\d+/.test(id);
}

export function isSeatsTier(id: string) {
  return /s\d+/.test(id);
}
